import React, { useState, useEffect } from 'react'
import moment from 'moment';
import Utilities from '../../../../../services/commonservice/utilities';
import { Accordion, Icon } from 'semantic-ui-react';
import InvoicePreview from '../invoice-preview/InvoicePreview';
import PaymentHistoryList from '../../report/paymentPlan-list/paymentPlan-card/payment-history-accordion/payment-history-list/PaymentHistoryList';
import PaymentsList from '../../report/paymentPlan-list/paymentPlan-card/payments-accordion/payments-list/PaymentsList';
import InvoiceButtonGroup from '../../../../../services/commonservice/invoice-button-group.utility';

const InvoiceCard = (props) => {
    const [show, setShow] = useState(false)
    const [activeIndex, setActiveIndex] = useState()
    useEffect(() => {
        if (props.keyword) {
            setActiveIndex()
        }
    }, [props.keyword])

    return (
        <div className='card mb-3 p-3'>
            <div className='row d-flex mx-0 remove-gutter'>
                <div className='point col-12 d-flex align-items-center' onClick={e => { e.preventDefault(); setShow(!show) }}>
                    <div className='row d-flex w-100 remove-gutter'>
                        <h5 className='col-md-8 col-12 invoice-card__header'>
                                {props.transaction.invoiceNumber && <span>{props.transaction.invoiceNumber}<span className='not-mobile'> | </span></span>}
                                <span><strong>{props.transaction.patientName}</strong><span className='not-mobile'> | </span></span>
                                <span>
                                    {props.transaction.invoiceType !== 3 && props.transaction.amountPaid && (0 < props.transaction.amountPaid < props.transaction.finalAmount) && props.transaction.amountPaid !== props.transaction.finalAmount ? Utilities.toDollar(props.transaction.finalAmount - props.transaction.amountPaid) + ' /' : null} {Utilities.toDollar(props.transaction.finalAmount)}
                                </span>
                                <span>
                                    {props.transaction.inProcessAmount && props.transaction.inProcessAmount > 0 ? <span className='not-mobile'> | Processing: {Utilities.toDollar(props.transaction.inProcessAmount) }</span> : null}
                                </span>
                        </h5>
                        <div className='col-md-4 col-12'>
                            <div className='d-flex row justify-content-end'>
                                <div className='col-md-auto col-12 btn-group' onClick={e => e.stopPropagation()}>
                                    <InvoiceButtonGroup
                                        // buttonClass={'p-0 ps-1'}
                                        initialData={props.transaction}
                                        invoiceId={props.transaction.id}
                                        //extraButton={extraButtons}
                                        refresh={() => { props.refresh() }}
                                    ></InvoiceButtonGroup>
                                </div>
                            </div>
                        </div>
                        <div className='col-12 text-start justify-content-between'>
                            <div className='row d-flex invoice-card__details'>
                                <span className='col'><strong>Provider: </strong>{props.transaction.doctorName}</span>
                                {props.transaction.createdOn && <span className='col text-center'><strong className='ms-5'>Created On: </strong>{moment(props.transaction.createdOn).format("M-D-YYYY")}</span>}
                                {props.transaction.serviceDate && <span className='col text-center'><strong className='ms-5'>Service Date: </strong>{moment(props.transaction.serviceDate).format("M-D-YYYY")}</span>}
                                {props.transaction.dueDate && <span className='col text-end'><strong className={`ms-5 ${new Date(props.transaction.dueDate) <= new Date() && 'text-danger'}`}>Due Date: </strong>{moment(props.transaction.dueDate).format("M-D-YYYY")}</span>}
                            </div>
                        </div>
                    </div>
                </div>
                {show &&
                    <div className='col-12 mt-3'>
                        <Accordion fluid styled>
                            <Accordion.Title
                                active={activeIndex === 0}
                                index={0}
                                onClick={e => { e.preventDefault(); if (activeIndex === 0) { setActiveIndex() } else { setActiveIndex(0) } }}
                            > <Icon name='dropdown' />Preview</Accordion.Title>
                            <Accordion.Content active={activeIndex === 0}>
                                <InvoicePreview transaction={props.transaction} pull={activeIndex === 0} />
                            </Accordion.Content>
                            {props.transaction.invoiceStatus === 5 || props.transaction.invoiceStatus === 6 || props.transaction.invoiceStatus === 7 || props.transaction.invoiceStatus === 8 ? <Accordion.Title
                                active={activeIndex === 1}
                                index={1}
                                onClick={e => { e.preventDefault(); if (activeIndex === 1) { setActiveIndex() } else { setActiveIndex(1) } }}
                            > <Icon name='dropdown' />Upcoming Payments</Accordion.Title> : null}
                            <Accordion.Content active={activeIndex === 1}>
                                <PaymentsList paymentPlanId={props.transaction.paymentId} patientId={props.transaction.patientId} autoPull={activeIndex === 1} />
                            </Accordion.Content>
                            <Accordion.Title
                                active={activeIndex === 2}
                                index={2}
                                onClick={e => { e.preventDefault(); if (activeIndex === 2) { setActiveIndex() } else { setActiveIndex(2) } }}
                            > <Icon name='dropdown' />Payment History</Accordion.Title>
                            <Accordion.Content active={activeIndex === 2}>
                                <PaymentHistoryList paymentPlan={props.transaction} autoPull={activeIndex === 2} refresh={() => { props.refresh() }}/>
                            </Accordion.Content>
                        </Accordion>
                    </div>
                }
            </div>
        </div>
    )
}
export default InvoiceCard